import { ApiSlice } from "../api/Api";

interface Customer {
  id: string;
  usedName: string;
  name: string;
  surname: string;
  alias: string;
  commercialTitle: string;
  citizenOrTaxNumber: string;
  email: string;
  customerDetail: {
    id: string;
    leadToCustomerDate: string;
    isTaxFree: boolean;
    isEInvoiceUser: boolean;
    isForeign: boolean;
    isCorporateService: boolean;
    supplierTypeId: string;
    eCommerceDescription: string;
    technicalEmail: string;
    businessPartnerId: string;
    partnerLevelId: string;
    customerCode: string;
    description: string;
    creationSource: string;
    parentId: string;
    customerId: string;
    adSourceId: string;
    conditionId: string;
    sectorId: string;
    statusId: string;
    taxFreeReasonId: string;
    taxOfficeId: string;
    isSubsidiary: boolean;
    isPublicCustomer: boolean;
    isBusinessPartner: boolean;
  };
  customerKindId: 2;
  customerTypeId: 2;
  ownerId: string;
  customerTags: [];
  customerAlarmTypes: [];
  customerAlarmSeverityTypes: [];
  creationTime: string;
  dateOfBirth: string;
  customerCode: number;
}

interface Status {
  id: string;
  name: string;
  description: string | null;
}

interface Condition {
  id: string;
  name: string;
  description: string | null;
}

interface Response<T> {
  data: T;
  errors: any;
  isSuccessful: boolean;
  pageNumber: number;
  statusCode: number;
  totalItemCount: number;
}

export const customerApi = ApiSlice.injectEndpoints({
  endpoints: (build) => ({
    getCustomer: build.query<Response<Customer>, string | undefined>({
      query: (id) => `fixity/customer/customer/${id}`,
      //providesTags: (_post, _err, id) => [{ type: "Customer", id }],
    }),
    getCustomerStatus: build.query<Response<Status>, string | undefined>({
      query: (id) => `fixity/customer/status/${id}`,
    }),
    getCustomerCondition: build.query<Response<Condition>, string | undefined>({
      query: (id) => `fixity/customer/condition/${id}`,
    }),
  }),
});

export const {
  useGetCustomerQuery,
  useGetCustomerStatusQuery,
  useGetCustomerConditionQuery,
} = customerApi;

export const {
  endpoints: { getCustomer, getCustomerStatus, getCustomerCondition },
} = customerApi;
